import type { ListBuilderConfiguration } from '../types';
import {
	buildPurchaseOrderColumns,
	PURCHASE_ORDER_REQUIRED_FIELDS,
} from './purchase-order-columns';

/**
 * Purchase orders embedded on a vendor's detail page. Same column set as the
 * main list (`purchase-order-columns.ts`) minus the Vendor column, since every
 * row here belongs to the vendor being viewed.
 */
export const PURCHASE_ORDER_VENDOR_EMBEDDED_CONFIG: ListBuilderConfiguration = {
	lists: [
		{
			id: 'default-purchase-orders-vendor-embedded',
			cacheTTL: 600000,
			name: 'Vendor Purchase Orders',
			type: 'default',
			active: true,
			columns: buildPurchaseOrderColumns({ includeVendor: false }),
			description: 'Purchase orders for this vendor',
			defaultSortId: 'column-order-date-desc',
			requiredFields: PURCHASE_ORDER_REQUIRED_FIELDS,
			sortOrder: 0,
		},
	],
	paging: {
		defaultPageSize: 25,
		pageSizeOptions: [25, 50, 100],
	},
	filters: {
		activeFilters: ['purchaseOrderKeywords', 'purchaseOrderStatus'],
		defaultFilters: {},
	},
	objects: [
		{
			baseUrl: '/purchase-orders/:id',
			objectLabel: 'Purchase Order',
			objectTable: 'purchase_order',
			selectedFields: [
				{ fieldName: '_id', fieldLabel: 'ID' },
				{ fieldName: 'externalId', fieldLabel: 'External ID' },
				{ fieldName: 'status', fieldLabel: 'Status' },
				{ fieldName: 'date', fieldLabel: 'Order Date' },
				{ fieldName: 'requestedDate', fieldLabel: 'Requested Date' },
				{ fieldName: '_created_date', fieldLabel: 'Created Date' },
			],
		},
	],
	tableSorts: [
		{
			id: 'po-number',
			name: 'PO Number',
			fields: [{ direction: 'ASC', fieldName: 'externalId' }],
			description: 'Sort by PO number',
		},
		{
			id: 'status',
			name: 'Status',
			fields: [{ direction: 'ASC', fieldName: 'status' }],
			description: 'Sort by status',
		},
		{
			id: 'order-date',
			name: 'Order Date',
			fields: [{ direction: 'DESC', fieldName: 'date' }],
			description: 'Sort by order date (newest first)',
		},
		{
			id: 'requested-date',
			name: 'Requested Date',
			fields: [{ direction: 'DESC', fieldName: 'requestedDate' }],
			description: 'Sort by requested date (newest first)',
		},
	],
};
